import { render, staticRenderFns } from "./LoaderClock.vue?vue&type=template&id=71924bc7&scoped=true&"
var script = {}
import style0 from "./LoaderClock.vue?vue&type=style&index=0&id=71924bc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71924bc7",
  null
  
)

export default component.exports